import Fn from 'jj-browser-fn';
import PageApi from '@/apis/pageApi'
// import decode from "./decode";
import AES from "@/utils/AES";
import CryptoJS from "crypto-js"
import { Toast, Dialog } from "vant"
import store from "@/store/index"
import user from '@/store/module/user';

const ProjFn = {
    ...Fn,
    // 跳转路由
    toRoute: (route: string) => {
        window.App.$router.push({
            path: route,
        })
    },
    backLogin: () => {
        window.App.$router.push({
            path: PageApi.login.path,
        })
    },
    // 添加全局公共方法
    checkHttpResponse: (res: any, errorFn: any, isNotice: boolean) => {
        return new Promise((resolve) => {
            if (res && ProjFn.n(res.code) === 200) {
                resolve(res.data)
            } else {
                // tslint:disable-next-line:no-unused-expression
                errorFn ? errorFn(res) : '';
                if (isNotice) {
                    window.App.$Message.error(res.msg)
                }
            }
        })
    },
    showMsgResponse: (res: any, errorFn?: any) => {
        return ProjFn.checkHttpResponse(res, errorFn, true)
    },
    handleResponse: (res: any, errorFn: any) => {
        return ProjFn.checkHttpResponse(res, errorFn, false)
    },
    // 接口验签
    toSign: (obj) => {
        const sign = sessionStorage.getItem('gamechannel');
        // 按照升序排序obj属性
        const sortObj = obj;
        if(sessionStorage.getItem('gameid2') === null){
            sortObj.game_id = sessionStorage.getItem('gameid');
        }else{
            sortObj.game_id = sessionStorage.getItem('gameid2');
        }
        sortObj.appid = sessionStorage.getItem('appid');
        const newkey = Object.keys(sortObj).sort();
        const newObj: any = {};
        newkey.forEach((item, i) => {
            // 遍历newkey数组
            newObj[newkey[i]] = sortObj[newkey[i]];
            // 向新创建的对象中按照排好的顺序依次增加键值对
        })
        const keyArr = new Array();
        for (const y in newObj) {
            if (true) {
                const x = newObj[y];
                if (typeof newObj[y] === "object") {
                    keyArr.push(y + "=" + JSON.stringify(x.map(String)))
                    // keyArr.push(y + "=" + x)
                } else {
                    keyArr.push(y + "=" + x)
                }
            }
        }
        // const sign = sessionStorage.getItem('gamechannel');
        // const key = "d52b97d91e74f8f9fdb9aa9cff64deb3";
        const key = AES.decrypt(sign);
        // console.log(sign)
        // console.log(key)
        // var text = "249223b121ab27f0045a0a4beba882f7";
        // var encoded = AES.encrypt(text);
        // console.log(encoded.toString());
        // console.log(AES.decrypt(encoded));
        const keySign = keyArr.join("&");
        const result = CryptoJS.HmacSHA1(keySign,key).toString(CryptoJS.enc.Hex);
        newObj.sign = result
        return newObj;
    },
    // 截取url中的数据
    getUrlData: () => {
        const temp = window.location.href;
        const search = window.location.search;
        const tempStr = decodeURIComponent(decodeURIComponent(temp));
        const tempArr = tempStr.split('?')[1] ? tempStr.split('?')[1].split('&') : []
        tempArr.forEach(element => {
            sessionStorage.setItem(element.split('=')[0], element.split('=')[1])
        })
        console.log(temp)
        const tempObj = {};
        tempArr.forEach((item, i) => {
            tempObj[item.split('=')[0]] = item.split('=')[1]
        })
        if (tempObj.appid === '24894' && tempObj.gameid === '3809' && tempObj.gamechannel === 'tgJ95i3QRRt4n6X9hzc2UCfchrZG3E1pcDQ7VYOcMddykJE6Xp0w2fshk0ztd4xN'){
            console.log('对了就是这个游戏')
            window.location.href="http://h5game.996m2.com/v1/home?appid=48433&gameid=7928&gamechannel=lxt6J3cLE1SfJ%2FZkdSWOW4BOUk%2Bc1m7TB%2Baia2VS7IGirPf4inqCcZDE5trNhGJA&game_name=%25E5%2587%2580%25E5%259C%259F%25E6%2580%2580%25E6%2597%25A7%25E7%2589%25B9%25E6%2588%2592%25E7%2589%2588&domain=http%3A%2F%2Fcdn.dhsf.xqhuyu.com&logo=&use_native_browser=0&sdk_app_id=9J33DbFvNwJ0&sdk_channel_id=&sdk_app_key=0e1e3ca5947f8cbd9c4186b22492ec96";
            return
        }
        if (search) {
            store.dispatch('user/authSearchUrl', tempObj)
        }
    },
    // 清除数据
    getEmpty: () => {
        console.log('清空')
        store.dispatch('user/authInfo', {})
    },
    // 验证手机格式
    isTel: (tel) => {
        return /(^[1][2,3,4,5,6,7,8,9][0-9]{9}$)|(^[2,8,6][0-9]{7}$)|(^[2,3,5,6,9][0-9]{7}$)/.test(tel);
    },
    delUserInfo: async () => {
        await window.App.$store.dispatch('user/authInfo', {})
    },
    // 检查身份证是否符合规范
    isCardNo: (card) => {
        const reg = /(^\d{15}$)|(^\d{17}(\d|X)$)/
        return reg.test(card);

    },
    // 检测是否为字母+数字
    isReg: (str) => {
        const z = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]*$/;
        const s = /^[a-zA-Z][-_a-zA-Z0-9]*$/g;
        if (str.length === 0) {
            Toast("账号不能为空");
            return false;
        } else if (!s.test(str)) {
            Toast("账号需由字母开头");
            return false;
        } else if (!z.test(str)) {
            Toast("账号需由字母和数字组成");
            return false;
        }
        return true;
    },
    isRegFigure: (str) => {
        const z = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]*$/;
        if (!z.test(str)) {
            Toast("密码需由字母和数字组成");
            return false;
        }
        return true;
    },
    // 检测首字符是否为字母
    isMyRegExp: (str) => {
        const myRegExp = new RegExp("^[a-zA-Z]");
        return !!myRegExp.exec(str);

    },
    // 手机号中间4位数隐藏
    getMapping: (str) => {
        return str.substring(0, 3) + "****" + str.substring(7, str.length);
    },
    // 复制内容
    copyText: (value, that) => {
        const aux = document.createElement('input')
        aux.setAttribute('value', value)
        document.body.appendChild(aux)
        aux.select()
        document.execCommand('copy')
        document.body.removeChild(aux)
        Toast('复制成功')
    },
}

export default ProjFn;


